import {useAlert, useAuth} from "../../context";
import {Navigate} from "react-router-dom";
import React, {useEffect, useRef} from "react";

export function Logout() {
    const {logout} = useAuth()
    const {success} = useAlert()
    const renderRef = useRef(true)

    useEffect(() => {
        if (renderRef.current) {
            // Just prevents double rendering in Strict mode
            logout().then(() => success("Session ended successfully.", "Logged Out"))
            renderRef.current = false
        }
    }, []);

    return <Navigate to="/"/>
}